import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PaymentReceipt, PaymentStateModel } from './payment.model';
import { PaymentState } from './payment.state';

@Injectable({
  providedIn: 'root',
})
export class PaymentQuery {
  @Select(PaymentState.loading) loading$!: Observable<boolean>;
  @Select(PaymentState.result) result$!: Observable<any>;
  @Select(PaymentState.error) error$!: Observable<string | null>;
  @Select(PaymentState.paymentReceipt) paymentReceipt$!: Observable<PaymentReceipt | null>;
  @Select(PaymentState.paymentError) paymentError$!: Observable<string | null>;

  get result() {
    return this.getState()?.result;
  }

  get loading(): boolean {
    return this.getState()?.loading || false;
  }

  get error(): string | null {
    return this.getState()?.error || null;
  }

  get paymentReceipt(): PaymentReceipt | null {
    return this.getState()?.paymentReceipt || null;
  }

  get paymentError(): string | null {
    return this.getState()?.paymentError || null;
  }

  private getState(): PaymentStateModel | undefined {
    return undefined;
  }
}
